import React from 'react';
import NotificationList from '../components/Notification/NotificationList';

const NotificationPage: React.FC = () => <NotificationList />;

export default NotificationPage; 